import { useForm } from 'react-hook-form';
import z from 'zod';
import { signupSchema } from '../../../schemas/signupSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  clearTemporalSession,
  getTemporalSession,
} from '../../../utils/tempSession';
import { useDialog } from '../../../context/Dialog';
import WelcomeMessageDialog from '../../../components/auth-components/signup/dialogs/WelcomeMessageDialog';
import { useQueryClient } from '@tanstack/react-query';

// const initialFormData: z.infer<typeof signupSchema> = {
//   //store contact information
//   // store_category: 'pharmacy_store',
//   role_type: 'store_owner',
//   first_name: '',
//   last_name: '',
//   email: '',
//   password: '',
//   confirm_password: '',
//   phone: '',
//   token: '',
//   //store information
//   ref_code: '',
//   // chargeCurrency: "",
//   // chargeRate: "",
//   // store_name: '',
//   // store_address: '',
//   // store_license: undefined,
//   pay_account: '',
//   bank: '',
//   account_name: '',
//   account_number: '',
// };

export default function () {
  const history = useHistory();
  const location = useLocation();
  const { openDialog } = useDialog();
  const query = new URLSearchParams(location.search);
  /**
   * @description currentStep is the step number on form, not the index of step component in steps array
   */
  const currentStep = Number(query.get('step')) || 1;
  const clientQuery = useQueryClient();

  const formHandler = useForm<z.infer<typeof signupSchema>>({
    resolver: zodResolver(signupSchema),
    defaultValues: {
      role_type: 'store_owner',
    },
  });

  /**
   *
   * @param step is the step number you want to move to, not the index of the step component in the steps array
   */
  const handleStepChange = (step: number) => {
    history.push(`/auth/sign-up?step=${step}`);
  };

  // SERVES AS A MINI ROUTE GUARD
  const miniRouteGuard = () => {
    //get temporal section
    const tempUser = getTemporalSession() || undefined;

    // WE USE AUTHORIZATION LEVEL TO DETERMINE THE STEP THEY FALL ON THE SIGNUP FLOW
    let authLevel = 1;

    if (tempUser) {
      authLevel += 1; // USER HAS ACCOUNT BUT MIGHT NOT BE VERIFIED

      if ('isVerified' in tempUser && tempUser.isVerified) {
        authLevel += 1; // USER HAS ACCOUNT AND IS VERIFIED
      }
    }

    // REROUTE USER IF THEY DO NOT HAVE THE RIGHT AUTHORIZATION LEVEL
    if (authLevel < 3 && currentStep > authLevel)
      history.replace(`/auth/sign-up?step=${authLevel}`);

    if (authLevel == 1 && tempUser) clearTemporalSession();

    if (currentStep > 2 && authLevel > 2) {
      history.replace(`/auth/sign-up?step=${2}`);
      handleSubmission();
    }

    if (tempUser && currentStep > 1) {
      formHandler.reset(tempUser);
    }
  };

  React.useEffect(() => {
    miniRouteGuard();
  }, [location.search]);

  const handleSubmission = () => {
    openDialog(
      <WelcomeMessageDialog
        onNext={() => {
          clientQuery.clear();
          clearTemporalSession();
        }}
      />,
      {
        allowBackgroundDismiss: false,
      }
    );
  };

  return {
    currentStep,
    handleStepChange,
    handleSubmission,
    formHandler,
  };
}
